window._ = require('lodash');
try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

require('./main');
